import Vue from 'vue';
import VueRouter from 'vue-router';
import wagbapproRoutes from './routes/wagbappro';

Vue.use(VueRouter);

/* 解决访问重复路由报错问题 */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export const constRoutesPc = wagbapproRoutes;

const routes = wagbapproRoutes;

export default function createRouter() {
  return new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      return { x: 0, y: 0 };
    },
  });
}
